import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { TeamsMessage } from './types/teamsMessage';

/**
 * @internal
 */
export class ApiTeams extends ApiBaseMidBack {
  send(params: ParamsAdapter) {
    return this.post<TeamsMessage>('/teams/teams-message', params);
  }
}
